import { jsx as _jsx } from "react/jsx-runtime";
import { isArabic } from '@/config/constants';
import styles from './Options.module.scss';
export const Options = ({ options, handleOptionClick, disabled }) => {
    return (_jsx("li", { className: styles.textOptionsContainer, children: _jsx("ul", { children: options === null || options === void 0 ? void 0 : options.map(({ label, text }) => (_jsx("button", { disabled: disabled, className: styles.textOption, tabIndex: 0, dir: isArabic(label), onClick: () => handleOptionClick(text, label), children: label }, label))) }) }));
};
